import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { FundHeaderEntryComponent } from './fund-header-entry/fund-header-entry.component';
import { FundTitleComponent } from './fund-title/fund-title.component';
import { SummaryComponent } from './summary/summary.component';
import { SummaryInternationalComponent } from './summary/summary-international/summary-international.component';
import { SummaryUSComponent } from './summary/summary-us/summary-us.component';
import { FundSummaryService } from './services/fund-summary.service';
import { FundTitleService } from './services/fund-title.service';
import {
  DialogModule,
  HeaderDocumentListModule,
  LogoModule,
  SimpleModalModule,
  LinkModule,
  FlyoutMenuModule,
} from '@frk/eds-components';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MorningStarDetailsComponent } from './summary/morning-star-details/morning-star-details.component';
import { SignInModalModule } from '@shared/sign-in-modal/sign-in-modal.module';
import { HeaderDocumentsComponent } from './header-documents/header-documents.component';
import { FundHeaderAlertsComponent } from './fund-header-alerts/fund-header-alerts.component';
@NgModule({
  declarations: [
    FundHeaderEntryComponent,
    FundTitleComponent,
    FundHeaderAlertsComponent,
    SummaryComponent,
    SummaryInternationalComponent,
    SummaryUSComponent,
    MorningStarDetailsComponent,
    HeaderDocumentsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    DialogModule,
    HeaderDocumentListModule,
    NgxSkeletonLoaderModule,
    SimpleModalModule,
    LogoModule,
    LinkModule,
    SignInModalModule,
    FlyoutMenuModule,
  ],
  entryComponents: [
    FundHeaderEntryComponent,
    FundTitleComponent,
    SummaryComponent,
  ],
  providers: [FundSummaryService, FundTitleService],
})
export class FundHeaderModule {}

export const fundHeaderModuleComponentMapping = {
  'Fund Header': FundHeaderEntryComponent,
};
